import { getClassifierApiUrl } from '@/lib/runtimeConfig';
export async function fetchMessageDetail(graphToken, messageId) {
    const res = await fetch(`${getClassifierApiUrl()}/api/messages/${encodeURIComponent(messageId)}`, {
        headers: { Authorization: `Bearer ${graphToken}` },
    });
    const text = await res.text();
    if (!res.ok) {
        try {
            const json = JSON.parse(text);
            throw new Error(json.error || `Message API ${res.status}`);
        }
        catch (err) {
            if (err instanceof Error && err.message !== 'Unexpected end of JSON input') {
                throw err;
            }
            throw new Error(`Message API ${res.status}`);
        }
    }
    const json = JSON.parse(text);
    return json.message;
}
